import { FC, useContext } from 'react';

import { LocaleIcon } from '@smartshell/ui-kit';
import cn from 'classnames';

import { useOutsideClicker } from 'hooks';
import {
  getLanguageTitle,
  LANGUAGE_OPTIONS,
  LocalizationContext,
} from 'localization';

import s from './LoginLanguageSwitcher.module.scss';

export const LoginLanguageSwitcher: FC = () => {
  const { t, lang, setLang } = useContext(LocalizationContext);
  const { ref, isComponentVisible, setIsComponentVisible } =
    useOutsideClicker<HTMLDivElement>(false, s.options);

  return (
    <div className={s.container} ref={ref}>
      {isComponentVisible && (
        <div className={s.options} role="listbox" aria-label={t('language')}>
          {LANGUAGE_OPTIONS.map(({ value, title }) => (
            <button
              aria-selected={value === lang}
              className={cn(s.option, value === lang && s.selected)}
              key={value}
              onClick={() => {
                setLang(value);
                setIsComponentVisible(false);
              }}
              role="option"
              type="button"
            >
              {title}
            </button>
          ))}
        </div>
      )}

      <button
        aria-expanded={isComponentVisible}
        aria-haspopup="listbox"
        aria-label={t('language')}
        className={s.trigger}
        data-testid="login-language-switcher"
        onClick={() => setIsComponentVisible((isVisible) => !isVisible)}
        type="button"
      >
        <LocaleIcon />
        <span>{getLanguageTitle(lang)}</span>
      </button>
    </div>
  );
};
